/** Shared chrome for Clerk-hosted auth. Appearance comes from ClerkProvider. */
export default function ClerkAuthShell({ children, testId }) {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center px-4"
      style={{ background: "#0a0a0a" }}
      data-testid={testId}
    >
      <a
        href="/"
        className="mb-6 text-lg font-semibold tracking-tight hover:opacity-80"
        style={{ color: "#F4F4F5", fontFamily: "Chivo, sans-serif" }}
      >
        MarkovLab
      </a>
      {children}
      <p className="mt-8 max-w-xs text-center text-[10px]" style={{ color: "#555" }}>
        Educational and informational purposes only. Not investment advice.
      </p>
    </div>
  );
}
